import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './BusinessExamples.styles';
import {
  EXAMPLE_KEYS,
  EXAMPLE_IMAGES,
  useExamplesScroll,
} from './BusinessExamples.helpers';
import useScreenSize from '@/hooks/useScreenSize';

export const BusinessExamples: React.FC = () => {
  const { t } = useTranslation();
  const { isLarge } = useScreenSize();
  const { scrollWrapperRef, canScrollLeft, canScrollRight, scrollExamples } =
    useExamplesScroll(isLarge);

  return (
    <S.BusinessExamplesSection>
      <S.BusinessExamplesTitle>
        {t('business.examples.title')}
      </S.BusinessExamplesTitle>
      <S.BusinessExamplesScrollOuter>
        <S.BusinessExamplesScrollWrapper ref={scrollWrapperRef}>
          <S.BusinessExamplesContainer>
            {EXAMPLE_KEYS.map((exampleKey, index) => {
              const imageName = EXAMPLE_IMAGES[index];
              return (
                <S.BusinessExampleCard key={exampleKey}>
                  <S.BusinessExampleContent>
                    <S.BusinessExampleHeader>
                      <S.BusinessExampleAvatar
                        src={`/images/business/examples/${imageName}.jpg`}
                        alt={t(`business.examples.${exampleKey}.name`)}
                        loading="eager"
                        fetchPriority="high"
                      />
                      <S.BusinessExampleInfo>
                        <S.BusinessExampleName>
                          {t(`business.examples.${exampleKey}.name`)}
                        </S.BusinessExampleName>
                        <S.BusinessExampleCategory>
                          {t(`business.examples.${exampleKey}.category`)}
                        </S.BusinessExampleCategory>
                      </S.BusinessExampleInfo>
                    </S.BusinessExampleHeader>
                    <S.BusinessExampleStatBlock>
                      <S.BusinessExampleStatValue>
                        {t(`business.examples.${exampleKey}.stat`)}
                      </S.BusinessExampleStatValue>
                      <S.BusinessExampleStatLabel>
                        {t(`business.examples.${exampleKey}.impactLabel`)}
                      </S.BusinessExampleStatLabel>
                    </S.BusinessExampleStatBlock>
                    <S.BusinessExampleQuote>
                      {t(`business.examples.${exampleKey}.quote`)}
                    </S.BusinessExampleQuote>
                  </S.BusinessExampleContent>
                </S.BusinessExampleCard>
              );
            })}
            <S.BusinessExamplesScrollSpacer aria-hidden="true" />
          </S.BusinessExamplesContainer>
        </S.BusinessExamplesScrollWrapper>
        <S.BusinessExamplesScrollButtonsWrapper>
          {isLarge && canScrollLeft && (
            <S.ExamplesScrollButton
              $side="left"
              type="button"
              onClick={() => scrollExamples('left')}
              aria-label={t('common.previous')}
            />
          )}
          {isLarge && canScrollRight && (
            <S.ExamplesScrollButton
              $side="right"
              type="button"
              onClick={() => scrollExamples('right')}
              aria-label={t('common.next')}
            />
          )}
        </S.BusinessExamplesScrollButtonsWrapper>
      </S.BusinessExamplesScrollOuter>
    </S.BusinessExamplesSection>
  );
};
